module.exports = __webpack_public_path__ + "img/96.43dd8523.jpg";